import React from 'react';

import './TableHeader.scss';

export interface HeadItem {
  text: string | number;
  key?: string;
  style?: any;
}

export interface HeaderProps {
  items: HeadItem[];
  defaultSort?: string;
  onSortChange?: (key: string, type: string) => void;
}

export interface State {
  sortKey: string;
  sortType: string;
}

class TableHeader extends React.Component<HeaderProps, State> {

  state = {
    sortKey: null,
    sortType: 'asc'
  }

  constructor(props: HeaderProps) {
    super(props);
    if (props.defaultSort) {
      this.state.sortKey = props.defaultSort;
    }
  }

  render() {
    return (
      <tr className="table-header-component">
        {this.props.items.map(item => (
          <th
            key={item.text}
            style={this.getStyles(item)}
            className={this.getClasses(item)}
            onClick={item.key != null ? this.handleClick.bind(this, item) : null}>
            {item.text}
            {this.getAngle(item)}
          </th>
        ))}
      </tr>
    );
  }

  getStyles = (item: HeadItem) => {
    return (item.style) ? item.style : {};
  }

  getClasses = (item: HeadItem) => {
    return (item.key) ? 'sortable' : '';
  }

  getAngle = (item: HeadItem) => {
    const defaultReturn = <i className="far ic-empty"></i>;
    if (this.state.sortKey === null) return defaultReturn;
    if (item.key === this.state.sortKey) {
      if (this.state.sortType === 'asc') {
        return <i className="fas fa-angle-up"></i>;
      }
      return <i className="fas fa-angle-down"></i>;
    }
    return defaultReturn;
  }

  handleClick = (item: HeadItem) => {
    const { sortKey, sortType } = this.state;
    const update: Partial<State> = {};
    if (sortKey === item.key) {
      update.sortType = (sortType === 'asc') ? 'desc' : 'asc';
    }
    else {
      update.sortKey = item.key;
    }
    this.setState(update as State, () => {
      const { onSortChange } = this.props;
      if (onSortChange) {
        onSortChange(this.state.sortKey, this.state.sortType);
      }
    });
  }

}

export default TableHeader;
